import { render, staticRenderFns } from "./portfolio-info.vue?vue&type=template&id=708ec80c&scoped=true"
import script from "./portfolio-info.ts?vue&type=script&lang=ts&external"
export * from "./portfolio-info.ts?vue&type=script&lang=ts&external"
import style0 from "./portfolio-info.scss?vue&type=style&index=0&id=708ec80c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708ec80c",
  null
  
)

export default component.exports